import type { SettingMenuArray } from "../types/settingsTypes";
export const SettingMenu: SettingMenuArray = [
  {
    id: 1,
    title: "SettingMenu.アカウント",
    type: "account",
    icon: "user",
  },
  {
    id: 2,
    title: "SettingMenu.通知設定",
    type: "notification",
    icon: "comment",
  },
  {
    id: 3,
    title: "SettingMenu.2要素認証",
    type: "two-factor-auth",
    icon: "verification",
  },
  {
    id: 4,
    title: "SettingMenu.会社情報・請求先情報",
    type: "company-billing-info",
    icon: "company",
  },
  {
    id: 5,
    title: "SettingMenu.メンバー管理",
    type: "member-management",
    icon: "people",
  },
  {
    id: 6,
    title: "SettingMenu.ゲスト管理",
    type: "guest-management",
    icon: "guest",
  },
  {
    id: 7,
    title: "SettingMenu.プラン・支払い",
    type: "plan-and-billing",
    icon: "credit_card",
  },
  {
    id: 8,
    title: "SettingMenu.共通設定",
    type: "common",
    icon: "settingBlack",
  },
  {
    id: 9,
    title: "SettingMenu.セキュリティ",
    type: "security",
    icon: "key",
  },
];
